import './styles.scss';
import './last-transition-end';

;(($) => {
  
  if (undefined === $) {
    return console.warn('[jQuery.drawmer] jQuery not found!');
  }

  const _CLASSES = {
    shown: 'is-shown',
    body: {
      open: 'jquery-drawer-open'
    }
  };

  const _ATT = {
    close:    'data-drawmer-close',
    drawer:   'data-drawmer',
    toggle:   'data-drawmer-toggle',
    backdrop: 'data-drawmer-backdrop',
  };

  $.drawmer = {
    instances: {},
    get: id => {
      if ($.drawmer.instances[id]) {
        return $.drawmer.instances[id];
      }    
      return undefined;
    },
  };
  
  /**
   * jquery drawer
   * 
   * Elements with [(data-drawmer-{toggle|backdrop|close})="drawer-id"] will perform the correspective action on drawer or element
   * 
   * Minimum html requirements
   * Css not included
   *  
   *  <[div|a|button] data-drawmer-toggle=[drawer-id] />
   *  ...
   *  <div data-drawmer-backdrop=[drawer-id] />
   *  <div data-drawmer=[drawer-id]>
   *    <[div|a|button] data-drawmer-close />
   *  </div>
   * 
   * @param {object} options 
   * @returns object
   */
  $.fn.drawmer = function( options ) {
    if($(this).length <= 0) {
      return console.warn('[jQuery.drawmer] found 0 ref');
    }
    options = $.extend({
      onOpen() {},
      onClose() {},
      onShown() {},
      onHidden() {},
      onToggle() {},
      active() { return true; },
      ui: {
        open: null,
        close: null,
      }
    }, options);

    let isShown = false;
    const $drawer = $(this);
    const drawerId = $drawer.attr(_ATT.drawer);
    const $closeButton = $drawer.find(`[${_ATT.close}]`);
    const $body = $(document.body);
    options.ui.close = $closeButton;
    options.ui.open = $(`[${_ATT.toggle}=${drawerId}]`);

    const instance = {
      id: drawerId,
      dom: $drawer,
      open,
      close,
      toggle,
      options,     
      get isShown() {
        return isShown;
      },
    };

    // Events
    $body.on(`${drawerId}:open`, open);
    $body.on(`${drawerId}:close`, close);
    $body.on(`${drawerId}:toggle`, toggle);
    $closeButton.on('click', close);
    
    // transition end
    $drawer.propTransitionEnd('visibility', event => {
      isShown = !isShown;
      if (!isShown) {
        $body.trigger(`${drawerId}:on-hidden`, [{isShown, $drawer}]);  
        options.onHidden.call($drawer, [{ isShown, $drawer}]);
      } else {
        $body.trigger(`${drawerId}:on-shown`, [{isShown, $drawer}]);  
        options.onShown.call($drawer, [{isShown, $drawer}]);
      }
    });

    // button and backdrop toggle
    $(`[${_ATT.toggle}=${drawerId}], [${_ATT.backdrop}=${drawerId}]`).on('click', function(event) {
      event.preventDefault();
      toggle();
    });

    function open() {
      if(!options.active()) return;
      lockBody();
      $body.trigger(`${drawerId}:on-open`, [{ isShown, $drawer }]);  
      options.onOpen.call($drawer, [{ isShown, $drawer}]);
      $drawer.addClass(_CLASSES.shown);
      $(`[${_ATT.backdrop}=${drawerId}]`).addClass(_CLASSES.shown);
    }
    
    function close(event) {
      if(!options.active()) return;
      if(event) event.preventDefault();
      lockBody();
      $body.trigger(`${drawerId}:on-close`, [{ isShown, $drawer }]);  
      options.onClose.call($drawer, [{ isShown, $drawer}]);
      $drawer.removeClass(_CLASSES.shown);
      $(`[${_ATT.backdrop}=${drawerId}]`).removeClass(_CLASSES.shown);
    }

    function toggle() {
      if(!options.active()) return;
      if (!isShown) {
        open();
      } else {
        close();
      }
    }

    function lockBody() {
      if(!isShown) {
        document.body.style.paddingRight = 
          window.innerWidth - document.documentElement.clientWidth + 'px';
        document.body.style.overflow = 'hidden';
        document.body.classList.add(_CLASSES.body.open);
        document.body.classList.add(`${drawerId}-open`);
      } else {
        document.body.style.paddingRight = 'initial';
        document.body.style.overflow = 'auto';
        document.body.classList.remove(_CLASSES.body.open);
        document.body.classList.remove(`${drawerId}-open`);
      }
    }

    $.drawmer.instances[drawerId] = instance;

    return instance;
  };

})(window.jQuery);